var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"mx-1",class:{'grey--text lighten-1': _vm.isDark, 'grey--text darken-1': !_vm.isDark},attrs:{"x-small":""},domProps:{"textContent":_vm._s(_vm.icons.mdiPencilOffOutline)}})
}
var staticRenderFns = []

export { render, staticRenderFns }